import React from 'react';
import styled from 'styled-components';
import { 
  FiFile, FiTrendingUp, FiDollarSign, FiSearch, 
  FiFileText, FiList, FiBriefcase, FiCheckSquare,
  FiMapPin, FiBell, FiSettings, FiArrowUp, FiArrowDown,
  FiKey, FiCalendar, FiClock, FiZap, 
  FiFolder, FiFolderPlus, FiMail, FiPhone, FiMessageSquare,
  FiUser, FiUsers, FiHome, FiGlobe, FiPackage,
  FiShoppingCart, FiCreditCard, FiBarChart, FiPieChart,
  FiActivity, FiAward, FiBookmark, FiBook, FiTarget,
  FiTag, FiStar, FiHeart, FiThumbsUp, FiEdit,
  FiTrash, FiCopy, FiClipboard, FiDownload, FiUpload,
  FiSend, FiImage, FiVideo, FiMusic, FiCamera,
  FiMonitor, FiSmartphone, FiServer, FiDatabase
} from 'react-icons/fi';

// Base component for custom icons - ALL USE SAME GRADIENT
const CustomIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  margin: auto;
  
  & > svg {
    width: 14px;
    height: 14px;
    color: white;
    stroke-width: 2.5;
    display: block;
  }
`;

// All icons now use the same purple gradient for consistency
export const DocumentIcon = () => (<CustomIcon><FiFile /></CustomIcon>);
export const ChartIcon = () => (<CustomIcon><FiTrendingUp /></CustomIcon>);
export const MoneyIcon = () => (<CustomIcon><FiDollarSign /></CustomIcon>);
export const SearchIcon = () => (<CustomIcon><FiSearch /></CustomIcon>);
export const TextIcon = () => (<CustomIcon><FiFileText /></CustomIcon>);
export const ListIcon = () => (<CustomIcon><FiList /></CustomIcon>);
export const BriefcaseIcon = () => (<CustomIcon><FiBriefcase /></CustomIcon>);
export const ChecklistIcon = () => (<CustomIcon><FiCheckSquare /></CustomIcon>);
export const PinIcon = () => (<CustomIcon><FiMapPin /></CustomIcon>);
export const BellIcon = () => (<CustomIcon><FiBell /></CustomIcon>);
export const GearIcon = () => (<CustomIcon><FiSettings /></CustomIcon>);
export const ChartUpIcon = () => (<CustomIcon><FiArrowUp /></CustomIcon>);
export const ChartDownIcon = () => (<CustomIcon><FiArrowDown /></CustomIcon>);
export const KeyIcon = () => (<CustomIcon><FiKey /></CustomIcon>);
export const CalculatorIcon = () => (<CustomIcon><FiCalendar /></CustomIcon>);
export const AlarmIcon = () => (<CustomIcon><FiClock /></CustomIcon>);
export const LightbulbIcon = () => (<CustomIcon><FiZap /></CustomIcon>);
export const FolderIcon = () => (<CustomIcon><FiFolder /></CustomIcon>);
export const FolderOpenIcon = () => (<CustomIcon><FiFolderPlus /></CustomIcon>);
export const MailIcon = () => (<CustomIcon><FiMail /></CustomIcon>);
export const PhoneIcon = () => (<CustomIcon><FiPhone /></CustomIcon>);
export const MessageIcon = () => (<CustomIcon><FiMessageSquare /></CustomIcon>);
export const UserIcon = () => (<CustomIcon><FiUser /></CustomIcon>);
export const UsersIcon = () => (<CustomIcon><FiUsers /></CustomIcon>);
export const HomeIcon = () => (<CustomIcon><FiHome /></CustomIcon>);
export const GlobeIcon = () => (<CustomIcon><FiGlobe /></CustomIcon>);
export const PackageIcon = () => (<CustomIcon><FiPackage /></CustomIcon>);
export const ShoppingCartIcon = () => (<CustomIcon><FiShoppingCart /></CustomIcon>);
export const CreditCardIcon = () => (<CustomIcon><FiCreditCard /></CustomIcon>);
export const BarChartIcon = () => (<CustomIcon><FiBarChart /></CustomIcon>);
export const PieChartIcon = () => (<CustomIcon><FiPieChart /></CustomIcon>);
export const ActivityIcon = () => (<CustomIcon><FiActivity /></CustomIcon>);
export const AwardIcon = () => (<CustomIcon><FiAward /></CustomIcon>);
export const BookmarkIcon = () => (<CustomIcon><FiBookmark /></CustomIcon>);
export const BookIcon = () => (<CustomIcon><FiBook /></CustomIcon>);
export const TargetIcon = () => (<CustomIcon><FiTarget /></CustomIcon>);
export const TagIcon = () => (<CustomIcon><FiTag /></CustomIcon>);
export const StarIcon = () => (<CustomIcon><FiStar /></CustomIcon>);
export const HeartIcon = () => (<CustomIcon><FiHeart /></CustomIcon>);
export const ThumbsUpIcon = () => (<CustomIcon><FiThumbsUp /></CustomIcon>);
export const EditIcon = () => (<CustomIcon><FiEdit /></CustomIcon>);
export const TrashIcon = () => (<CustomIcon><FiTrash /></CustomIcon>);
export const CopyIcon = () => (<CustomIcon><FiCopy /></CustomIcon>);
export const ClipboardIcon = () => (<CustomIcon><FiClipboard /></CustomIcon>);
export const DownloadIcon = () => (<CustomIcon><FiDownload /></CustomIcon>);
export const UploadIcon = () => (<CustomIcon><FiUpload /></CustomIcon>);
export const SendIcon = () => (<CustomIcon><FiSend /></CustomIcon>);
export const ImageIcon = () => (<CustomIcon><FiImage /></CustomIcon>);
export const VideoIcon = () => (<CustomIcon><FiVideo /></CustomIcon>);
export const MusicIcon = () => (<CustomIcon><FiMusic /></CustomIcon>);
export const CameraIcon = () => (<CustomIcon><FiCamera /></CustomIcon>);
export const MonitorIcon = () => (<CustomIcon><FiMonitor /></CustomIcon>);
export const SmartphoneIcon = () => (<CustomIcon><FiSmartphone /></CustomIcon>);
export const ServerIcon = () => (<CustomIcon><FiServer /></CustomIcon>);
export const DatabaseIcon = () => (<CustomIcon><FiDatabase /></CustomIcon>); 